import { MgSupplierItemClimateDTO } from '../../dto';

export interface BoverketCalculationA {
  boverketA1A3Litre?: number;
  boverketA1A3M2?: number;
  boverketA1A3Meter?: number;
  boverketA1A3PrimaryPackage?: number;
  boverketA4Litre?: number;
  boverketA4M2?: number;
  boverketA4Meter?: number;
  boverketA4PrimaryPackage?: number;
  boverketA5Litre?: number;
  boverketA5M2?: number;
  boverketA5Meter?: number;
  boverketA5PrimaryPackage?: number;
}
export interface BoverketDataA {
  boverketA1A3KG?: number;
  boverketA1KG?: number;
  boverketA2KG?: number;
  boverketA3KG?: number;
  boverketA4KG?: number;
  boverketA5KG?: number;
}

export interface BoverketDataV2 {
  boverketCalculationA?: BoverketCalculationA;
  boverketDataA?: BoverketDataA;
  boverketResourceId?: string;
}

export interface EpdCalculationA {
  calculatedGwpGhgA1A3KG?: number;
  calculatedGwpGhgA1A3Litre?: number;
  calculatedGwpGhgA1A3M2?: number;
  calculatedGwpGhgA1A3Meter?: number;
  calculatedGwpGhgA1A3PrimaryPackage?: number;
  calculatedGwpGhgA1KG?: number;
  calculatedGwpGhgA1Litre?: number;
  calculatedGwpGhgA1M2?: number;
  calculatedGwpGhgA1Meter?: number;
  calculatedGwpGhgA1PrimaryPackage?: number;
  calculatedGwpGhgA2KG?: number;
  calculatedGwpGhgA2Litre?: number;
  calculatedGwpGhgA2M2?: number;
  calculatedGwpGhgA2Meter?: number;
  calculatedGwpGhgA2PrimaryPackage?: number;
  calculatedGwpGhgA3KG?: number;
  calculatedGwpGhgA3Litre?: number;
  calculatedGwpGhgA3M2?: number;
  calculatedGwpGhgA3Meter?: number;
  calculatedGwpGhgA3PrimaryPackage?: number;
  calculatedGwpGhgA4KG?: number;
  calculatedGwpGhgA4Litre?: number;
  calculatedGwpGhgA4M2?: number;
  calculatedGwpGhgA4Meter?: number;
  calculatedGwpGhgA4PrimaryPackage?: number;
  calculatedGwpGhgA5KG?: number;
  calculatedGwpGhgA5Litre?: number;
  calculatedGwpGhgA5M2?: number;
  calculatedGwpGhgA5Meter?: number;
  calculatedGwpGhgA5PrimaryPackage?: number;
  calculatedGwpTotalA1A3KG?: number;
}

export interface EpdCalculationB {
  calculatedGwpGhgB1B3B5B7KG?: number;
  calculatedGwpGhgB1B3B5B7Litre?: number;
  calculatedGwpGhgB1B3B5B7M2?: number;
  calculatedGwpGhgB1B3B5B7Meter?: number;
  calculatedGwpGhgB1B3B5B7PrimaryPackage?: number;
  calculatedGwpGhgB1B5KG?: number;
  calculatedGwpGhgB1B5Litre?: number;
  calculatedGwpGhgB1B5M2?: number;
  calculatedGwpGhgB1B5Meter?: number;
  calculatedGwpGhgB1B5PrimaryPackage?: number;
  calculatedGwpGhgB1B7KG?: number;
  calculatedGwpGhgB1B7Litre?: number;
  calculatedGwpGhgB1B7M2?: number;
  calculatedGwpGhgB1B7Meter?: number;
  calculatedGwpGhgB1B7PrimaryPackage?: number;
  calculatedGwpGhgB1KG?: number;
  calculatedGwpGhgB1Litre?: number;
  calculatedGwpGhgB1M2?: number;
  calculatedGwpGhgB1Meter?: number;
  calculatedGwpGhgB1PrimaryPackage?: number;
  calculatedGwpGhgB2KG?: number;
  calculatedGwpGhgB2Litre?: number;
  calculatedGwpGhgB2M2?: number;
  calculatedGwpGhgB2Meter?: number;
  calculatedGwpGhgB2PrimaryPackage?: number;
  calculatedGwpGhgB3KG?: number;
  calculatedGwpGhgB3Litre?: number;
  calculatedGwpGhgB3M2?: number;
  calculatedGwpGhgB3Meter?: number;
  calculatedGwpGhgB3PrimaryPackage?: number;
  calculatedGwpGhgB4KG?: number;
  calculatedGwpGhgB4Litre?: number;
  calculatedGwpGhgB4M2?: number;
  calculatedGwpGhgB4Meter?: number;
  calculatedGwpGhgB4PrimaryPackage?: number;
  calculatedGwpGhgB5KG?: number;
  calculatedGwpGhgB5Litre?: number;
  calculatedGwpGhgB5M2?: number;
  calculatedGwpGhgB5Meter?: number;
  calculatedGwpGhgB5PrimaryPackage?: number;
  calculatedGwpGhgB6KG?: number;
  calculatedGwpGhgB6Litre?: number;
  calculatedGwpGhgB6M2?: number;
  calculatedGwpGhgB6Meter?: number;
  calculatedGwpGhgB6PrimaryPackage?: number;
  calculatedGwpGhgB7KG: number;
  calculatedGwpGhgB7Litre: number;
  calculatedGwpGhgB7M2: number;
  calculatedGwpGhgB7Meter: number;
  calculatedGwpGhgB7PrimaryPackage: number;
}

export interface EpdCalculationC {
  calculatedGwpGhgC1C4KG?: number;
  calculatedGwpGhgC1C4Litre?: number;
  calculatedGwpGhgC1C4M2?: number;
  calculatedGwpGhgC1C4Meter?: number;
  calculatedGwpGhgC1C4PrimaryPackage?: number;
  calculatedGwpGhgC1KG?: number;
  calculatedGwpGhgC1Litre?: number;
  calculatedGwpGhgC1M2?: number;
  calculatedGwpGhgC1Meter?: number;
  calculatedGwpGhgC1PrimaryPackage?: number;
  calculatedGwpGhgC2KG?: number;
  calculatedGwpGhgC2Litre?: number;
  calculatedGwpGhgC2M2?: number;
  calculatedGwpGhgC2Meter?: number;
  calculatedGwpGhgC2PrimaryPackage?: number;
  calculatedGwpGhgC3KG?: number;
  calculatedGwpGhgC3Litre?: number;
  calculatedGwpGhgC3M2?: number;
  calculatedGwpGhgC3Meter?: number;
  calculatedGwpGhgC3PrimaryPackage?: number;
  calculatedGwpGhgC4KG?: number;
  calculatedGwpGhgC4Litre?: number;
  calculatedGwpGhgC4M2?: number;
  calculatedGwpGhgC4Meter?: number;
  calculatedGwpGhgC4PrimaryPackage?: number;
}

export interface EpdCalculationD {
  calculatedGwpGhgDKG?: number;
  calculatedGwpGhgDLitre?: number;
  calculatedGwpGhgDM2?: number;
  calculatedGwpGhgDMeter?: number;
  calculatedGwpGhgDPrimaryPackage?: number;
}

export interface CalculatedFromEpd {
  byGtin: {
    gtin: string;
  };
  epdCalculationA?: EpdCalculationA;
  epdCalculationB?: EpdCalculationB;
  epdCalculationC?: EpdCalculationC;
  epdCalculationD?: EpdCalculationD;
}
export interface EpdMetaData {
  epdAssetLink?: string;
  epdComment?: string;
  epdFunctionalUnit?: string;
  epdFunctionalUnitWeight: number;
  epdId?: string;
  epdLastModified?: string;
  epdModel?: string;
  epdOwner?: string;
  epdProductName?: string;
  epdPublisher?: string;
  epdStandard?: string;
  epdValidTo?: string;
  externalDatasetId?: string;
  externalDatasetUrl?: string;
  finfoNumber?: number;
  identifiers?: {
    finfoSupplierId?: number;
    gtin?: string;
    supplierArticleId?: string;
  };
}

export interface EpdDataGwpA {
  epdGwpBiogenicA1A3?: number;
  epdGwpBiogenicA4?: number;
  epdGwpBiogenicA5?: number;
  epdGwpFossilA1A3?: number;
  epdGwpFossilA4?: number;
  epdGwpFossilA5?: number;
  epdGwpLulucA1A3?: number;
  epdGwpLulucA4?: number;
  epdGwpLulucA5?: number;
  epdGwpTotalA1A3?: number;
  epdGwpTotalA4?: number;
  epdGwpTotalA5?: number;
}

export interface EpdDataGwpB {
  epdGwpBiogenicB1?: number;
  epdGwpBiogenicB1B3B5B7?: number;
  epdGwpBiogenicB1B5?: number;
  epdGwpBiogenicB1B7?: number;
  epdGwpBiogenicB2?: number;
  epdGwpBiogenicB3?: number;
  epdGwpBiogenicB4?: number;
  epdGwpBiogenicB5?: number;
  epdGwpBiogenicB6?: number;
  epdGwpBiogenicB7?: number;
  epdGwpFossilB1?: number;
  epdGwpFossilB1B3B5B7?: number;
  epdGwpFossilB1B5?: number;
  epdGwpFossilB1B7?: number;
  epdGwpFossilB2?: number;
  epdGwpFossilB3?: number;
  epdGwpFossilB4?: number;
  epdGwpFossilB5?: number;
  epdGwpFossilB6?: number;
  epdGwpFossilB7?: number;
  epdGwpLulucB1?: number;
  epdGwpLulucB1B3B5B7?: number;
  epdGwpLulucB1B5?: number;
  epdGwpLulucB1B7?: number;
  epdGwpLulucB2?: number;
  epdGwpLulucB3?: number;
  epdGwpLulucB4?: number;
  epdGwpLulucB5?: number;
  epdGwpLulucB6?: number;
  epdGwpLulucB7?: number;
  epdGwpTotalB1?: number;
  epdGwpTotalB1B3B5B7?: number;
  epdGwpTotalB1B5?: number;
  epdGwpTotalB1B7?: number;
  epdGwpTotalB2?: number;
  epdGwpTotalB3?: number;
  epdGwpTotalB4?: number;
  epdGwpTotalB5?: number;
  epdGwpTotalB6?: number;
  epdGwpTotalB7?: number;
}

export interface EpdDataGwpC {
  epdGwpBiogenicC1?: number;
  epdGwpBiogenicC1C4?: number;
  epdGwpBiogenicC2?: number;
  epdGwpBiogenicC3?: number;
  epdGwpBiogenicC4?: number;
  epdGwpFossilC1?: number;
  epdGwpFossilC1C4?: number;
  epdGwpFossilC2?: number;
  epdGwpFossilC3?: number;
  epdGwpFossilC4?: number;
  epdGwpLulucC1?: number;
  epdGwpLulucC1C4?: number;
  epdGwpLulucC2?: number;
  epdGwpLulucC3?: number;
  epdGwpLulucC4?: number;
  epdGwpTotalC1?: number;
  epdGwpTotalC1C4?: number;
  epdGwpTotalC2?: number;
  epdGwpTotalC3?: number;
  epdGwpTotalC4?: number;
}

export interface EpdDataGwpD {
  epdGwpBiogenicD?: number;
  epdGwpFossilD?: number;
  epdGwpLulucD?: number;
  epdGwpTotalD?: number;
}

export interface EpdDataGwpGhgA {
  epdGwpGhgA1?: number;
  epdGwpGhgA1A3?: number;
  epdGwpGhgA2?: number;
  epdGwpGhgA3?: number;
  epdGwpGhgA4?: number;
  epdGwpGhgA5?: number;
}
export interface EpdDataGwpGhgB {
  epdGwpGhgB1?: number;
  epdGwpGhgB1B3B5B7?: number;
  epdGwpGhgB1B5?: number;
  epdGwpGhgB1B7?: number;
  epdGwpGhgB2?: number;
  epdGwpGhgB3?: number;
  epdGwpGhgB4?: number;
  epdGwpGhgB5?: number;
  epdGwpGhgB6?: number;
  epdGwpGhgB7?: number;
}
export interface EpdDataGwpGhgC {
  epdGwpGhgC1?: number;
  epdGwpGhgC1C4?: number;
  epdGwpGhgC2?: number;
  epdGwpGhgC3?: number;
  epdGwpGhgC4?: number;
}

export interface EpdDataGwpGhgD {
  epdGwpGhgD?: number;
}
export interface ExtractedFromEpd {
  epdDataGwpA?: EpdDataGwpA;
  epdDataGwpB?: EpdDataGwpB;
  epdDataGwpC?: EpdDataGwpC;
  epdDataGwpD?: EpdDataGwpD;
  epdDataGwpGhgA?: EpdDataGwpGhgA;
  epdDataGwpGhgB?: EpdDataGwpGhgB;
  epdDataGwpGhgC?: EpdDataGwpGhgC;
  epdDataGwpGhgD?: EpdDataGwpGhgD;
}

export interface FinfoClimateV2Updated {
  boverketData?: BoverketDataV2;
  calculatedFromEpd?: CalculatedFromEpd;
  epdMetaData?: EpdMetaData;
  extractedFromEpd?: ExtractedFromEpd;
}

export class MgSupplierItemClimate {
  finfoNumber: number;
  data: FinfoClimateV2Updated;

  constructor(finfoNumber: number, data: FinfoClimateV2Updated) {
    this.finfoNumber = finfoNumber;
    this.data = data;
  }

  static fromDto = (
    dto: MgSupplierItemClimateDTO | undefined
  ): MgSupplierItemClimate | undefined => {
    if (!dto) return undefined;

    const mapBoverketData = (data?: BoverketDataV2): BoverketDataV2 | undefined => {
      if (!data) return undefined;
      return {
        boverketCalculationA: data.boverketCalculationA,
        boverketDataA: data.boverketDataA,
        boverketResourceId: data.boverketResourceId,
      };
    };

    const mapCalculatedFromEpd = (data?: CalculatedFromEpd): CalculatedFromEpd | undefined => {
      if (!data) return undefined;
      return {
        byGtin: {
          gtin: data.byGtin.gtin,
        },
        epdCalculationA: data.epdCalculationA,
        epdCalculationB: data.epdCalculationB,
        epdCalculationC: data.epdCalculationC,
        epdCalculationD: data.epdCalculationD,
      };
    };

    const mapEpdMetaData = (meta?: EpdMetaData): EpdMetaData | undefined => {
      if (!meta) return undefined;
      return {
        epdAssetLink: meta.epdAssetLink,
        epdComment: meta.epdComment,
        epdFunctionalUnit: meta.epdFunctionalUnit,
        epdFunctionalUnitWeight: meta.epdFunctionalUnitWeight,
        epdId: meta.epdId,
        epdLastModified: meta.epdLastModified,
        epdModel: meta.epdModel,
        epdOwner: meta.epdOwner,
        epdProductName: meta.epdProductName,
        epdPublisher: meta.epdPublisher,
        epdStandard: meta.epdStandard,
        epdValidTo: meta.epdValidTo,
        externalDatasetId: meta.externalDatasetId,
        externalDatasetUrl: meta.externalDatasetUrl,
        finfoNumber: meta.finfoNumber,
        identifiers: meta.identifiers,
      };
    };

    const mapExtractedFromEpd = (extracted?: ExtractedFromEpd): ExtractedFromEpd | undefined => {
      if (!extracted) return undefined;
      return {
        epdDataGwpA: extracted.epdDataGwpA,
        epdDataGwpB: extracted.epdDataGwpB,
        epdDataGwpC: extracted.epdDataGwpC,
        epdDataGwpD: extracted.epdDataGwpD,
        epdDataGwpGhgA: extracted.epdDataGwpGhgA,
        epdDataGwpGhgB: extracted.epdDataGwpGhgB,
        epdDataGwpGhgC: extracted.epdDataGwpGhgC,
        epdDataGwpGhgD: extracted.epdDataGwpGhgD,
      };
    };

    const mappedData: FinfoClimateV2Updated = {
      boverketData: mapBoverketData(dto.data?.boverketData),
      calculatedFromEpd: mapCalculatedFromEpd(dto.data?.calculatedFromEpd),
      epdMetaData: mapEpdMetaData(dto.data?.epdMetaData),
      extractedFromEpd: mapExtractedFromEpd(dto.data?.extractedFromEpd),
    };

    return new MgSupplierItemClimate(dto.finfoNumber, mappedData);
  };
}
